import apiSlice from './apiSlice';

export const franchiseSeasonBySeasonInitialState = {
    franchiseDetails: {},
    recordsByFranchise: [],
};

export const {
    useFranchisesQuery,
    useFranchiseDetailsQuery,
    useFranchiseSeasonBySeasonRecordsQuery,
    useRosterQuery,
    useAllTimeRecordVsFranchiseQuery,
    usePlayoffFranchiseVsTeamQuery,
} = apiSlice;

export * as franchiseSelectors from './selectors';
export { default as franchiseViewTypes } from './viewTypes';
